import script from "./icon-two-tones-global-search.vue?vue&type=script&lang=ts&setup=true"
export * from "./icon-two-tones-global-search.vue?vue&type=script&lang=ts&setup=true"

import "./icon-two-tones-global-search.vue?vue&type=style&index=0&id=bfe26a74&lang=scss&scoped=true"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-bfe26a74"]])

export default __exports__